import { Routes, Route, Navigate } from "react-router-dom";
import AppShell from "./components/AppShell.jsx";
import Home from "./pages/Home.jsx";
import PlanTrip from "./pages/PlanTrip.jsx";
import TrackTrip from "./pages/TrackTrip.jsx";
import Africa from "./pages/Africa.jsx";
import Flights from "./pages/Flights.jsx";
import Stays from "./pages/Stays.jsx";
import Visas from "./pages/Visas.jsx";
import Experiences from "./pages/Experiences.jsx";
import Contact from "./pages/Contact.jsx";

export default function App() {
  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/plan-a-trip" element={<PlanTrip />} />
        <Route path="/track-trip" element={<TrackTrip />} />
        <Route path="/africa" element={<Africa />} />
        <Route path="/flights" element={<Flights />} />
        <Route path="/stays" element={<Stays />} />
        <Route path="/visas" element={<Visas />} />
        <Route path="/experiences" element={<Experiences />} />
        <Route path="/contact" element={<Contact />} />
        {/* Unknown routes fall back to the homepage. */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AppShell>
  );
}
